import { cn } from '@morpho-org/ui-v6/utils'
import { forwardRef, type HTMLAttributes, type PropsWithChildren } from 'react'

export interface CellSimpleTextProps extends PropsWithChildren<HTMLAttributes<HTMLSpanElement>> {}

/**
 * CellSimpleText component - Tailwind replica of dapp-ui-v5 CellSimpleText
 *
 * A simple text wrapper for table cells with default body styling.
 *
 * Matches v5 CellSimpleText behavior:
 * - Typography: body xxs regular
 * - Color: text body
 *
 * @example
 * ```tsx
 * <CellSimpleText>Simple cell content</CellSimpleText>
 * <CellSimpleText className="text-secondary-foreground">Custom styling</CellSimpleText>
 * ```
 */
const CellSimpleText = forwardRef<HTMLSpanElement, CellSimpleTextProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <span ref={ref} className={cn('text-2xs text-foreground', className)} {...props}>
        {children}
      </span>
    )
  }
)

CellSimpleText.displayName = 'CellSimpleText'

export { CellSimpleText }
